// @flow
import * as React from 'react';

import { Dismissible, View, Modal } from 'reshaped';

import { useTranslator } from '@gandi/translate';
import { LayersContext } from '@gandi/ui';

import { useModalContext } from 'src/Layout/context/Modal';

import styles from './ModalBlock.module.css';

export function ModalBlock(): React.MixedElement | null {
  const { __ } = useTranslator();
  const {
    active,
    onClose,
    onAfterClose,
    modalTitle: title,
    modalContent,
  } = useModalContext();

  const context = React.useContext(LayersContext);
  const containerRef = React.useRef<HTMLElement | null>(null);

  // Mount modal in specific Gandi UI layer if available
  containerRef.current = context?.overlays || globalThis.document?.body;

  // Block scroll on the document body when modal is open
  React.useEffect(() => {
    if (active) {
      // $FlowFixMe[incompatible-use]
      document.documentElement.style.overflow = 'hidden';
    }
    return () => {
      // $FlowFixMe[incompatible-use]
      document.documentElement.style.overflow = '';
    };
  }, [active]);

  return (
    <Modal
      containerRef={containerRef}
      active={active}
      onClose={onClose}
      position="end"
      padding={7}
      // ~ 490px
      size="35em"
      className={styles.root}
      onAfterClose={onAfterClose}
    >
      <View paddingInline={1} gap={6} height="100%">
        {/* $FlowFixMe[incompatible-type]: WithClose type */}
        {/* $FlowFixMe[prop-missing]: WithClose type */}
        <Dismissible
          className={styles.title}
          onClose={onClose}
          closeAriaLabel={__('Close')}
        >
          <Modal.Title>{title}</Modal.Title>
        </Dismissible>
        {modalContent}
      </View>
    </Modal>
  );
}
